/**
 * Created by lobin on 2019/1/21.
 */
import { request } from "../../plugins/axios";
const state = {
    ntqData:{},//内推圈数据
    serveData:[],//服务相关数据
    cooperate:[],//合作企业
    aboutData:{},//关于我们
};
const getters = {};

const actions = {
  /**
   * 获取内推圈数据--->后台管理（内推圈数据）
   * @param data
   * @return {Promise.<void>}
   */
  async getNtqData({commit}) {
     const { data } = await request({
      url: `/portal/ntq_data`
    });
    commit("setState", { key: "ntqData", data: data });
  },

  /**
   * 获取服务数据--->后台管理（服务管理）
   * @param data
   * @return {Promise.<void>}
   */
  async getServeData({commit},params) {
    const { data } = await request({
     url: `/portal/service`,
     params
   });
   commit("setState", { key: "serveData", data: data });
 },

   /**
   * 获取合作企业数据--->后台管理（合作企业管理）
   * @param data
   * @return {Promise.<void>}
   */
   async getCopeData({commit}) {
    const { data } = await request({
     url: `/portal/about_us/enterprise`,
   });
   commit("setState", { key: "cooperate", data: data });
 },

  /**
   * 获取关于我们的数据--->后台管理（合作企业管理）
   * @param data
   * @return {Promise.<void>}
   */
  async getAboutData({commit}) {
    const { data } = await request({
     url: `/portal/about_us/aboutUsInfo`,
   });
   commit("setState", { key: "aboutData", data: data });
 },






};
const mutations = {
  setState(state, { key, data }) {
    state[key] = data;
  }
};
export default {
  state,
  getters,
  actions,
  mutations
};
